<template>
  <v-dialog persistent :value="showResources" :width="'850'">
    <v-card>
      <popup-heading 
      title="RESOURCES" 
      subtitle="Resources list">
        <template slot="action">
          <v-btn
            depressed
            @click="closeModal()"
            fab 
            color="white"
            :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2' : 'ml-2'"
          >
            <v-icon dark class="primary--text">close</v-icon>
          </v-btn>
        </template>
      </popup-heading>
      <v-card-text class="pop-header-fixed-content popup-height">
        <div class="text-center mt-2">
          <v-pagination :total-visible="10" :circle="true"  v-model="page" :length="pageCount"></v-pagination>
        </div>
        <v-data-table
          :hide-default-header='true'
          :items="resources"
          class="pb-4 tabulardata remove-hover less-padding-tbl text-left"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          hide-default-footer
          @page-count="pageCount = $event"
        >
         <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.name">
                <td class="pr-0">
                  <p class="parent-resource"><i class="fas fa-chevron-right"></i> {{ item.display_name ? item.display_name : item.name }}</p>
                    <template v-if="item.sub_resources && item.sub_resources.length > 0">
                      <table width="100%" class="nested-table">
                        <tr v-bind:key="'inner'+ innerItem.id" v-for="innerItem in item.sub_resources">
                          <td>
                            <p class="parent-resource"><i class="fas fa-chevron-right dark-grey"></i> {{ innerItem.display_name ? innerItem.display_name : innerItem.name }}</p>
                              <template v-if="innerItem.sub_resources && innerItem.sub_resources.length > 0">
                                <table width="100%" class="nested-table">
                                  <tr v-bind:key="'inner'+ innerInnerItem.id" v-for="innerInnerItem in innerItem.sub_resources">
                                    <td class="tbl-resource"><i class="fas fa-chevron-right light-grey"></i> {{ innerInnerItem.display_name ? innerInnerItem.display_name  : innerInnerItem.name }}</td>
                                  </tr>
                                </table>
                              </template>
                          </td>
                        </tr>
                      </table>
                    </template>
                </td>
              </tr>
            </tbody>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            No results.
          </v-alert>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import Env from '@/env';
import AuthApi from '@/components/Controllers/AuthApis';
import Helper from '@/components/Controllers/Helpers';
import { mapActions, mapGetters } from 'vuex';
import { some, isEmpty } from 'lodash';

export default {
  data() {
    return {
      resources: [],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  computed: {
    ...mapGetters({
      showResources: 'superadminapps/showResources',
      showResourcesObj: 'superadminapps/showResourcesObj',
    }),
  },
  watch: {
    'showResourcesObj': function(val){
      if(!_.isEmpty(val)){
        // Fetch all resources for app
        this.fetchAllResourcesForApp(val.id);
      }
    }

  },
  created() {
    if(this.showResources) {
      this.closeModal();
    }
  },

  methods: {
   
    /**
     * Fetch resources by app id
     */
    fetchAllResourcesForApp(appId) {
      this.spinner(true);
      const url = `${Env.url}/api/v1/apps/${appId}/resources`;
      AuthApi.getApi(url, this.form)
        .then((res) => {
          this.resources = res.data.payload;
          this.spinner(false);
        })
        .catch(() => {
          this.spinner(false);
          console.log('Unable to fetch resource for the app');
        });
    },

  
    /**
     * Close update modal and remove assign values in form
     */
    closeModal() {
      this.setShowResources(false);
      this.setShowResourcesObj({});
      this.resources = [];
    },

    ...mapActions({
      setShowResources: 'superadminapps/setShowResources',
      setShowResourcesObj: 'superadminapps/setShowResourcesObj',
      spinner: 'spinner/spinnerStatus',
      snackbar: 'snackbar/snackbar',
    }),
  },
};
</script>

<style scoped>
p.parent-resource {
    margin-bottom: 0;
    padding: 15px;
}
</style>
